import PropTypes from 'prop-types';

import CustomSVGIcon from './CustomSVGIcon';

const Automat = ({ color = '', ...other }) => {
	return (
		<CustomSVGIcon {...other}>
			<path
				d="M19,9.71582553 C18.0011438,12.2854515 16.5500884,14.2595287 14.3219091,15.5703986 C12.0933555,16.8815233 9.68187584,17.0298371 7.1482375,16.6117807 C6.91198919,17.3762849 6.63558888,18.172358 6.31903657,19 L1,12.3813968 L8.90332417,9.71582553 C8.5350736,11.1753854 8.23299053,12.3509138 7.99707496,13.2424106 C12.1931444,14.8471049 15.7430176,12.4662568 19,9.71582553 Z M13.6809634,1 L19,7.61860321 L11.0966758,10.2841745 C11.4649264,8.82461457 11.7670095,7.64908621 12.002925,6.75758939 C7.80685558,5.1528951 4.25698243,7.53374325 1,10.2841745 C1.99885619,7.71454848 3.44991161,5.74047126 5.67809088,4.42960142 C7.90664448,3.11847674 10.3181242,2.97016293 12.8517625,3.3882193 C13.0880108,2.62371511 13.3644111,1.82764201 13.6809634,1 Z"
				id="automat"
				fill={color}
			/>
		</CustomSVGIcon>
	);
};

Automat.propTypes = {
	color: PropTypes.string,
};

export default Automat;
